import React from 'react'

export function ESignaturePreview({ state }) {
  const { eSignatures, recipients } = state

  const getRecipient = (applicationProfileId) =>
    recipients?.find((recipient) => recipient.id === applicationProfileId)

  return eSignatures?.map((eSignature) => {
    const recipient = getRecipient(eSignature.applicationProfileId)

    return (
      <div
        className='prose prose-sm border rounded-lg shadow bg-gray-50 p-5 mb-3'
        key={eSignature?.applicationProfileId}
      >
        <p>{eSignature?.message}</p>
        <div className='flex flex-row justify-between'>
          <span className='mr-3'>(to: {recipient?.profile?.first_name})</span>
        </div>
      </div>
    )
  })
}
